import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=360d3acd&scoped=true&"
import script from "./NewFolderModal.vue?vue&type=script&lang=js&"
export * from "./NewFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFolderModal.vue?vue&type=style&index=0&id=360d3acd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d3acd",
  null
  
)

export default component.exports